<template>
  <div v-if="details" class="listing-details py-6">
    <v-container>
      <h2 class="text-h5 mb-7">{{ $t("room_details") }}</h2>
      <v-row no-gutters>
        <v-col cols="12" md="7">
          <div class="mb-4" v-text="details.text" />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(item, index) in details.items"
          :key="`item-${index}`"
          cols="12"
          sm="6"
          md="4"
        >
          <v-img :src="item.image" class="mb-6" aspect-ratio="0.93" />
          <div
            class="text-subtitle-1 font-weight-semibold"
            v-text="item.title"
          />
          <small class="blue-grey--text text--lighten-1">
            <span
              v-text="`${item.room_for} guest${item.room_for > 1 ? 's' : ''}`"
            />
            <v-icon class="mx-2" size="3">fas fa-circle</v-icon>
            <span v-text="commaList(item.features)" />
          </small>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormattersMixin from "@/mixins/formatters-mixin";

export default {
  name: "listing-details",
  mixins: [FormattersMixin],
  props: { details: Object },
};
</script>

<style scoped></style>
